export const phones = [
  "07543668921",
  "0182759931",
  "07543698736",
  "07858674145",
  "07973847467",
  "07513274767",
  "07866518038",
  "07599419335",
  "07840862623",
  "01159873695",
  "01743369386",
  "07807804336",
  "07766066946",
  "02922413949",
  "07879424745",
  "07941952940",
  "01803520944",
  "07449303391",
  "07462068239",
  "01292442254",
  "07711661310",
  "01704534746",
  "01613367173",
  "01932216507",
  "07779976718",
  "01661842857",
  "02476266899",
  "07738761714",
  "01295278958",
  "01236786863",
  "07515543642",
  "01142421139",
  "02476337755",
  "01302844624",
  "01617255481",
  "07549010345",
  "07936571473",
  "01912432964",
  "07515696124",
  "01616781602",
  "07803597738",
  "01413166826",
  "07450294171",
  "01661823343",
  "01422347117",
  "07835304353",
  "07768122473",
  "07985766390",
  "07542704840",
  "07908591116",
  "01416343555",
  "07775660616",
  "07778677695",
  "07846217013",
  "01563543410",
  "07904064682",
  "01132582307",
  "01283530897",
  "07815978399",
  "07546716623",
  "07512425139",
  "01548562117",
  "07722420967",
  "07857416610",
  "01933441115",
  "07963563622",
  "07704323676",
  "07957957777",
  "07771391520",
  "01217160585",
  "01506676356",
  "07816588213",
  "07701349848",
  "07746028291",
  "07798925335",
  "01993850275",
  "07909115310",
  "07835027678",
  "07384733805",
  "01608641237",
  "07411174074",
  "07305423703",
  "07871399175",
  "07766388873",
  "07902648048",
  "07897712062",
  "07454561099",
  "07799796742",
  "07850479425",
  "07748383959",
  "07920801967",
];
